import { useEffect } from "react";
import { useData,useDispatch } from "./DataContext.js";

import { useSearchParams } from "react-router-dom";

import PlayArticles from "./PlayArticles.js";
import PlayNavbar from "./PlayNavbar.js";
import PauseModal from "./PauseModal.js";
import AmendmentEditModal from "./AmendmentEditModal.js";
import AmendmentPresentModal from "./AmendmentPresentModal.js";


export default function Play ()
{
    const gData = useData();
    const gDispatch = useDispatch();

    const [searchParams, setSearchParams] = useSearchParams();
    const code = searchParams.get("code") !== null ? searchParams.get("code") : "";

    useEffect(() => {
	if (code !== null && code !== "") gDispatch({ type: "groupLogin", data: { code } });
    }, [searchParams, gDispatch, code]);

    function submitLogin (data) { setSearchParams({ code: data.code }); }

    const loaded = gData.simID !== null && gData.sim[gData.simID] !== undefined;

    return (
	<>
	    <div className="position-fixed w-100">
		<PlayNavbar code={code} submitLogin={submitLogin} />
	    </div>
	    {loaded && (
		<>
		    <PlayArticles/>
		    <PauseModal/>
		    <AmendmentEditModal/>
		    <AmendmentPresentModal/>
		</>
	    )}
	</>
    );
}
